var exports = {
  "k": "xfd349460--46ee90--container",
};

module.exports = exports;
